import { useStaticQuery, graphql } from "gatsby"
export const AllStickyPost = () => {
  const { allContentfulBlogPost } = useStaticQuery(
    graphql`
      query AllStickyPostQuery {
        allContentfulBlogPost(
          sort: { fields: [publishDate], order: DESC }
          filter: { tags: { eq: "sticky" } }
        ) {
          edges {
            node {
              author {
                name
              }
              category {
                title
                description
              }
              title
              slug
              publishDate(formatString: "MMMM Do, YYYY")
              tags
              heroImage {
                fluid(maxWidth: 350, maxHeight: 196, resizingBehavior: SCALE) {
                  ...GatsbyContentfulFluid
                  base64
                  tracedSVG
                  srcWebp
                  srcSetWebp
                }
              }
              description {
                childMarkdownRemark {
                  html
                }
              }
            }
          }
        }
      }
    `
  )
  return allContentfulBlogPost
}
